import getImage from "../assets/images/ImageLoader";


const IconWrapper = ({ iconName, className = "", ...props }) => {
    const SVG = getImage(iconName);
    if (!SVG) return null;

    return <SVG className={className} {...props} />;
}
export default IconWrapper;